// aws-exports.js
const awsConfig = {
    Auth: {
        region: import.meta.env.VITE_REGION,
        userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
        userPoolWebClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
        identityPoolId: import.meta.env.VITE_ADMIN_COGNITO_IDENTITY_POOL_ID,
    },
    Storage: {
        AWSS3: {
            bucket: import.meta.env.VITE_BUCKET_NAME,
            region: import.meta.env.VITE_REGION,
        } 
    },
    Environment: {
        stage: import.meta.env.VITE_STAGE
    },
};
export default awsConfig;
  